import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps, Text, useAlert } from '@frontend/design-system';

type Props = {
  deleteContactList: (listId: string) => Promise<void>;
  listIdToDelete?: string;
  modalProps: ModalControlModalProps;
  setListIdToDelete: (listId?: string) => void;
};

export const DeleteListModal = ({ deleteContactList, listIdToDelete, modalProps, setListIdToDelete }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const alert = useAlert();

  const handleConfirm = async () => {
    if (!listIdToDelete) return;

    try {
      setListIdToDelete(undefined);
      modalProps.onClose();
      await deleteContactList(listIdToDelete);
    } catch (error) {
      alert.error(t('An error occurred while deleting list. Please try again.'));
      console.error('Failed to delete list', error);
    }
  };

  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Are You Sure?')}
      onConfirm={handleConfirm}
      destructive
      modalCss={{ minWidth: 600 }}
    >
      <Text>{t('Are you sure you want to delete this list?')}</Text>
    </ConfirmationModal>
  );
};
